<vwui-header>
  <h2 a11yPageTitleLevel="1">{{ 'PAGE_PROJECT_ANALYSIS_VERSIONS.title' | translate }}</h2>
</vwui-header>

<vwui-table [compactable]="false">
  <div slot="table-title">{{ tableConfig.title }}</div>
  <vwui-table-row>
    @for (column of tableConfig.columns; track column) {
      <vwui-table-header>
        {{ column.header}}
      </vwui-table-header>
    }
  </vwui-table-row>

  @if (loadingSpinnerService.isSpinnerVisible()) {
    <vwui-table-row>
      <vwui-spinner></vwui-spinner>
    </vwui-table-row>
  }

  @if (!loadingSpinnerService.isSpinnerVisible()) {
    @for (item of versions$ | async; track item.id) {
      <vwui-table-row>
        <vwui-table-column>
          {{ item.versionId }}
        </vwui-table-column>
          <vwui-table-column>
              {{ item.projectType?.name ?? '' }}
          </vwui-table-column>
        <vwui-table-column>
          {{ (item.isPublished ? 'PAGE_PROJECT_ANALYSIS_VERSIONS.published' : 'PAGE_PROJECT_ANALYSIS_VERSIONS.concept') | translate }}
        </vwui-table-column>
        @if (item.isPublished) {
          <vwui-table-column>
            {{ item.publishedAt | date: ('DATE.long' | translate) }}
          </vwui-table-column>
        }
        @if (!item.isPublished) {
          <vwui-table-column>
            <slot></slot>
          </vwui-table-column>
        }
        <vwui-table-column>
          @if (!item.isPublished) {
            <div class="button-group">
              <vwui-button (click)="openPublishModal(item)" [disabled]="false">
                {{ 'PAGE_PROJECT_ANALYSIS_VERSIONS.publish' | translate }}
              </vwui-button>
              <vwui-button (click)="editDefinition(item)">
                {{ 'PAGE_PROJECT_ANALYSIS_VERSIONS.edit' | translate }}
              </vwui-button>
            </div>
          }
        </vwui-table-column>
      </vwui-table-row>
    }
  }
</vwui-table>
